
import { defineComponent } from 'vue'

// employment information
interface EmploymentInfo {
  period: string,
  job: string
}

// educational information
interface EducationInfo {
  date: string,
  text: string
}

// grant information
interface GrantInfo {
  period: string,
  text: string
}

// award information
interface AwardInfo {
  date: string,
  text: string
}

// lecture information
interface LectureInfo {
  year: number,
  semester: string
  text: string
}

export default defineComponent({
  name: 'CVEn',
  data () {
    return {
      employments: [
        {
          period: 'May 2025-Aug 2027',
          job: `Visiting Scientist, Quantum Matter Theory Research Group<br/>
          RIKEN Center for Emergent Matter Science, Japan`
        },
        {
          period: 'Sep 2022-Present',
          job: `Assistant Professor, Yusuke Kato group<br/>
          Department of Basic Science, The University of Tokyo, Japan`
        },
        {
          period: 'Oct 2022-Mar 2025',
          job: `Visiting Scientist, Condensed Matter Theory Laboratory<br/>
          RIKEN Cluster for Pioneering Reserach, Japan`
        },
        {
          period: 'Apr 2020-Aug 2022',
          job: `Postdoctoral Researcher, Condensed Matter Theory Laboratory<br/>
          RIKEN Cluster for Pioneering Reserach, Japan`
        },
        {
          period: 'Apr 2017-Mar 2020',
          job: 'JSPS Research Fellowship for Young Scientists (DC1), Kyoto University'
        }
      ] as EmploymentInfo[],
      educations: [
        {
          date: 'Apr 2017-Mar 2020',
          text: `PhD from Department of Physics, Kyoto University<br/>
          (Supervisor: Prof. Youichi Yanase)<br/>
          PhD thesis: <a href="doc/publications/thesis/phd_thesis.pdf" target="_blank">Modern classification theory of superconducting gap nodes</a>`
        },
        {
          date: 'Apr 2015-Mar 2017',
          text: `Master of Science from Department of Physics, Kyoto University<br/>
          (Supervisor: Prof. Youichi Yanase)<br/>
          Master thesis (in Japanese): <a href="doc/publications/thesis/ms_thesis.pdf" target="_blank">磁気多極子秩序と共存する超伝導の研究</a>`
        },
        {
          date: 'Apr 2011-Mar 2015',
          text: 'Bachelor of Science from Faculty of Science, Kyoto University'
        },
        {
          date: 'Apr 2008-Mar 2011',
          text: 'Takasaki High School'
        }
      ] as EducationInfo[],
      grants: [
        {
          period: 'Apr 2025-Mar 2027',
          text: `Grant-in-Aid for Transformative Research Areas (A) “Chimera Quasiparticle for Novel Condensed-Matter Science
Administration Department” Publicly offered research [<a href="https://kaken.nii.ac.jp/ja/grant/KAKENHI-PUBLICLY-25H02113/" target="_blank">No. JP25H02113</a>]<br/>
          Research project: “Construction of a microscopic theory for angular-momentum conversion among quasiparticles in solids”<br/>
          Principal Investigator: Shuntaro Sumita<br/>
          Budget amount: 4,030,000 JPY`
        },
        {
          period: 'Apr 2023-Mar 2027',
          text: `Grant-in-Aid for Scientific Research (C) [<a href="https://kaken.nii.ac.jp/en/grant/KAKENHI-PROJECT-23K03333/" target="_blank">No. JP23K03333</a>]<br/>
          Research project: “Exploration of novel electromagnetic coupling in organic conductors by the combination of molecular arrangement and magnetic ordering”<br/>
          Principal Investigator: Hitoshi Seo<br/>
          Budget amount: 4,810,000 JPY`
        },
        {
          period: 'Apr 2023-Mar 2026',
          text: `Grant-in-Aid for Early-Career Scientists [<a href="https://kaken.nii.ac.jp/en/grant/KAKENHI-PROJECT-23K13056/" target="_blank">No. JP23K13056</a>]<br/>
          Research project: “Theoretical study of novel superconducting phenomena in strongly correlated systems with multiple degrees of freedom”<br/>
          Principal Investigator: Shuntaro Sumita<br/>
          Budget amount: 4,680,000 JPY`
        },
        {
          period: 'Apr 2017-Mar 2020',
          text: `Grant-in-Aid for JSPS Fellows (DC1) [<a href="https://kaken.nii.ac.jp/en/grant/KAKENHI-PROJECT-17J09908/" target="_blank">No. JP17J09908</a>]<br/>
          Research project: “Searching and understanding of exotic superconducting state induced by multipole order”<br/>
          Research fellow: Shuntaro Sumita<br/>
          Budget amount: 2,500,000 JPY`
        }
      ] as GrantInfo[],
      awards: [
        {
          date: 'Jul 2023',
          text: 'International Conference on Strongly Correlated Electron Systems 2023: Best Poster Award'
        },
        {
          date: 'Jun 2022',
          text: 'JPSJ Papers of Editors\' Choice'
        },
        {
          date: 'Apr 2022',
          text: 'PTEP Editors\' Choice'
        }
      ] as AwardInfo[],
      lectures: [
        {
          year: 2025,
          semester: 'A1A2',
          text: `Wednesday, Period 3-4 (13:00-16:40)<br/>
          Introductory Experiments I, II (Physics) [Natural Sciences I] / Introductory Experiments (Physics) [Natural Sciences II, III]<br/>
          College of Arts and Sciences: Junior Division, The University of Tokyo`
        },
        {
          year: 2025,
          semester: 'S1',
          text: `Period 3-4 (13:00-16:40) (for presentation class, 5 times)<br/>
          Introductory Experiments III (Physics)<br/>
          College of Arts and Sciences: Junior Division, The University of Tokyo`
        },
        {
          year: 2024,
          semester: 'A1A2',
          text: `Tuesday, Period 3-4 (13:00-16:40)<br/>
          Introductory Experiments I, II (Physics) [Natural Sciences I] / Introductory Experiments (Physics) [Natural Sciences II, III]<br/>
          College of Arts and Sciences: Junior Division, The University of Tokyo`
        },
        {
          year: 2024,
          semester: 'S1',
          text: `Period 3-4 (13:00-16:40) (for presentation class, 5 times)<br/>
          Introductory Experiments III (Physics)<br/>
          College of Arts and Sciences: Junior Division, The University of Tokyo`
        },
        {
          year: 2023,
          semester: 'A1A2',
          text: `Wednesday, Period 3-4 (13:00-16:40)<br/>
          Introductory Experiments I, II (Physics) [Natural Sciences I] / Introductory Experiments (Physics) [Natural Sciences II, III]<br/>
          College of Arts and Sciences: Junior Division, The University of Tokyo`
        },
        {
          year: 2023,
          semester: 'S1',
          text: `Tuesday, Period 3-4 (13:00-16:40)<br/>
          Introductory Experiments III (Physics)<br/>
          College of Arts and Sciences: Junior Division, The University of Tokyo`
        },
        {
          year: 2022,
          semester: 'A1A2',
          text: `Friday, Period 3-4 (13:00-16:40)<br/>
          Introductory Experiments I, II (Physics) [Natural Sciences I] / Introductory Experiments (Physics) [Natural Sciences II, III]<br/>
          College of Arts and Sciences: Junior Division, The University of Tokyo`
        }
      ] as LectureInfo[]
    }
  },
  emits: [
    'Activate'
  ],
  mounted () {
    console.log('mounted')
    this.$emit('Activate', this.activate())
  },
  methods: {
    activate () {
      return 'cv'
    }
  }
})
